import * as Turbo from '@hotwired/turbo';
import { Application } from '@hotwired/stimulus';

import { FrameRenderHandler } from 'common/utils/hotwired/frame_render_handler';
import { FrameMissingHandler } from 'common/utils/hotwired/frame_missing_handler';
import {
  turboStreamVisit,
  turboStreamDownload,
  turboStreamSetCookie,
} from 'common/utils/hotwired/stream_actions';
import { startAnyCableTurboStream } from 'common/utils/hotwired/start_anycable';

import ToggleClassListController from 'controllers/common/toggle_class_list_controller';
import TurboExternalRedirectController from 'controllers/common/turbo_external_redirect_controller';
import TurboFetchController from 'controllers/common/turbo_fetch_controller';
import TurboModalController from 'controllers/common/turbo_modal_controller';
import TurboModalFetchTogglerController from 'controllers/common/turbo_modal_fetch_toggler_controller';
import TurboModalTogglerController from 'controllers/common/turbo_modal_toggler_controller';

window.Turbo = Turbo;
window.Stimulus = Application.start();

Turbo.session.drive = false;

Turbo.StreamActions.visit = turboStreamVisit;
Turbo.StreamActions.download = turboStreamDownload;
Turbo.StreamActions.setCookie = turboStreamSetCookie;

document.addEventListener('turbo:frame-render', FrameRenderHandler.onEvent);
document.addEventListener('turbo:frame-missing', FrameMissingHandler.onEvent);

startAnyCableTurboStream();

window.Stimulus.register('toggle-class-list', ToggleClassListController);
window.Stimulus.register('turbo-external-redirect', TurboExternalRedirectController);
window.Stimulus.register('turbo-fetch', TurboFetchController);
window.Stimulus.register('turbo-modal', TurboModalController);
window.Stimulus.register('turbo-modal-fetch-toggler', TurboModalFetchTogglerController);
window.Stimulus.register('turbo-modal-toggler', TurboModalTogglerController);
